import * as React from 'react'
import useMobile from './hooks/useMobile'

const EmptyTable = (props) => {
    const { isMobile } = useMobile()
    
    return (
        <div className="shop-page" style={{
            width: isMobile ? '100%' : 'calc(100% - 280px)',
            height: '100vh',
            padding: isMobile ? 'var(--spacing-sm)' : '8px',
            marginLeft: isMobile ? '0' : '280px'
        }}>
            {!isMobile && (
                <h1 className="shop-page-title" style={{ 
                    marginTop: '8px',
                    marginBottom: '8px',
                    marginLeft: '0px',
                    fontSize: 'var(--text-2xl)',
                }}>
                    {props.name}
                </h1>
            )}
            
            <div className="empty-state">
                <div className="empty-state-icon">📋</div>
                <h3 className="empty-state-title">{props.name}</h3>
                <p className="empty-state-description">
                    {props.text}
                </p>
            </div>
        </div>
    )
}

export default EmptyTable